<script>
	import { derived } from 'svelte/store';
	import OptionConfig from './componentes/Config/OptionConfig.svelte';
    import { push } from 'svelte-spa-router';
    import AnimationContainer from './components/AnimationContainer.svelte';
    import Navbar from './components/Navbar.svelte';

    import Titlesection from "./components/Titlesection.svelte";
    import { autentificado, prefix, urlapi, viewsXpages,login,miPermiso } from './stores/store';
    import { verifyAccess } from './scripts';

    /* PERMISOS */
    let viewPage=false;

    if($login===false)
    {
        push('/login')
    } else if( $miPermiso.configuraciones.access===false ) {
        push('/sinpermiso')
    } else {
        viewPage=true;
    }
    /* FIN PERMISOS */

</script>

{#if viewPage===true}

<Navbar />

<AnimationContainer>
        <br/>
        <Titlesection>
            <span slot="title"><i class="bi bi-gear me-1" />Configuraciones</span>
            <span slot="toolbar"></span>
        </Titlesection>

        <div class="container mt-5">
            <div class="row">

                {#if $miPermiso.usuarios.access===true}
                    <div class='col-12 col-md-6'>
                        <OptionConfig title='Usuarios' desc='Administración de usuarios Administración de usuarios' icon='bi-people' link='usuarios'/>
                    </div>
                {/if}

                {#if $miPermiso.permisos.access===true}
                    <div class='col-12 col-md-6'>
                        <OptionConfig title='Roles de usuarios' desc='Grupos de permisos guardados en roles de usuario' icon='bi-shield-check' link='permisos'/>
                    </div>
                {/if}
                
                {#if $miPermiso.sucursales.access===true}
                    <div class='col-12  col-md-6'>
                        <OptionConfig title='Sucursales' desc='Administración de catálogo de sucursales catalogo' icon='bi-shop' link='sucursales'/>
                    </div>
                {/if}
                
                {#if $miPermiso.tokenfel.access===true}
                    <div class='col-12  col-md-6'>
                        <OptionConfig title='Token FEL' desc='Verificar y solicitar Token FEL' icon='bi-key' link='token'/>
                    </div>
                {/if}

                {#if $miPermiso.configglobal.access===true}
                    <div class='col-12  col-md-6'>
                        <OptionConfig title='Configuraciones Globales' desc='Configurarar opciones globales' icon='bi-gear' link='globales'/>
                    </div>
                {/if}

                <!-- <div class='col-12  col-md-6'>
                    <OptionConfig title='Movimientos' desc='Administración de catálogo de sucursales catalogo' icon='bi-arrows-move' link='movimientos'/>
                </div> -->
            </div>
        </div>
            
                
</AnimationContainer>
{/if}